












import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component<SearchBox>({})
export default class SearchBox extends Vue {
    @Prop({ type: String, required: true }) public readonly value!: string
    @Prop({ type: String, required: false, default: 'text' }) public readonly type!: string
    @Prop({ type: String, required: false, default: 'Search' }) public readonly placeholder!: string
    @Prop({
        type: Boolean,
        required: false,
        default: true
    })
    rounded?: boolean
}
